import { PricingProfilePartNumberType } from 'pricing/enums';
import { IPricingProfilePartNumber, IPricingProfilePartNumberForm } from 'pricing/types';

export const mapUpsertPricingProfilePartNumber = (
  structureId: number,
  data: IPricingProfilePartNumberForm,
  pricingProfilePartNumber?: IPricingProfilePartNumber
) => {
  const isFixedPrice = PricingProfilePartNumberType.PRICE === data.type;

  return {
    id: pricingProfilePartNumber?.id,
    part: data.part.number,
    manufacturerId: data.part.manufacturerId,
    uom: data.uom,
    structureId,
    fixedType: data.type,
    // Only the selected type is sent — the legacy modal disables (and so never submits) the other
    // input. The endpoint iterates fixed_price whenever that array is non-empty and writes what it
    // finds into whichever column fixed_type names, so sending both would save the price as the
    // margin. The selected key must survive getFormData's null/undefined drop even when empty,
    // otherwise the endpoint has no UOM to iterate over and silently saves nothing.
    fixedPrice: {
      [data.uom]: isFixedPrice ? data.price ?? '' : null,
    },
    fixedMargin: {
      [data.uom]: isFixedPrice ? null : data.margin ?? '',
    },
    purchasedCost: {
      [data.uom]: data.purchasedCost,
    },
    costFixed: {
      [data.uom]: data.cost,
    },
  };
};
